import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { Clock, ArrowRight, Loader2 } from "lucide-react";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Property } from "@/pages/Properties";
import PropertyCard from "@/components/PropertyCard";
import { useNavigate } from "react-router-dom";

const FeaturedDeals = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [properties, setProperties] = useState<Property[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLatest = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from("properties_view_2")
        .select("*")
        .eq("type", "Апартаменти")
        .order("updated_at", { ascending: false })
        .limit(4);

      if (!error && data) {
        setProperties(data as Property[]);
      }
      setLoading(false);
    };
    fetchLatest();
  }, []);

  return (
    <section id="deals" className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12">
          <div>
            <Badge variant="secondary" className="mb-4">
              <Clock className="h-3 w-3 mr-1" />
              {t.featuredDeals.badge}
            </Badge>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground">
              {t.featuredDeals.title}
            </h2>
            <p className="text-muted-foreground mt-2 max-w-lg">
              {t.featuredDeals.subtitle}
            </p>
          </div>
          <Button variant="outline" className="mt-4 md:mt-0" onClick={() => navigate("/properties")}>
            {t.featuredDeals.viewAll}
            <ArrowRight className="h-4 w-4 ml-2" />
          </Button>
        </div>

        {loading ? (
          <div className="flex justify-center py-12">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {properties.map((property, index) => (
              <div
                key={property.id}
                className="animate-fade-in"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <PropertyCard property={property} />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default FeaturedDeals;
